<mds-dialog [dialogTitle]="title" [id]="'caregiverDialog'">
    <mds-dialog-content>
        @if (data.mode === 'view') {
            @if (data.model; as model) {
                <!-- VIEW MODE -->
                <div class="flex flex-col gap-medpace">
                    <medpace-labeled-text [label]="'Primary Caregiver?'" [text]="model.isPrimary ? 'Yes' : 'No'" />
                    <medpace-labeled-text [label]="'First/Given Name'" [text]="model.firstName" />
                    @if (model.middleName) {
                        <medpace-labeled-text [label]="'Middle Name'" [text]="model.middleName" />
                    }
                    <medpace-labeled-text [label]="'Last/Surname'" [text]="model.lastName" />
                    @if (model.phone) {
                        <medpace-labeled-text [label]="'Phone Number'" [text]="model.phone" />
                    }
                    @if (model.email) {
                        <medpace-labeled-text [label]="'Email Address'" [text]="model.email" />
                    }
                    @if (model.relationship) {
                        <medpace-labeled-text [label]="'Relationship to Patient'" [text]="model.relationship" />
                    }
                    @if (model.preferredLang) {
                        <medpace-labeled-text [label]="'Preferred Language'" [text]="model.preferredLang" />
                    }
                    @if (model.gender) {
                        <medpace-labeled-text [label]="'Gender'" [text]="model.gender" />
                    }
                    @if (model.birthDate) {
                        <medpace-labeled-text
                            [label]="'Birthdate'"
                            [text]="model.birthDate | dateFormat: undefined : 'local' | uppercase"
                        />
                    }
                    <medpace-labeled-text
                        [label]="'Same Address as Patient?'"
                        [text]="model.addressSameAsPatient ? 'Yes' : 'No'"
                    />
                    @if (!model.addressSameAsPatient) {
                        @if (model.address1) {
                            <medpace-labeled-text [label]="'Address Line 1'" [text]="model.address1" />
                        }
                        @if (model.address2) {
                            <medpace-labeled-text [label]="'Address Line 2'" [text]="model.address2" />
                        }
                        @if (model.city) {
                            <medpace-labeled-text [label]="'City'" [text]="model.city" />
                        }
                        @if (model.state) {
                            <medpace-labeled-text [label]="'State/Region'" [text]="model.state" />
                        }
                        @if (model.zipcode) {
                            <medpace-labeled-text
                                [label]="'Zipcode/Postal Code'"
                                [text]="model.zipcode || 'Unspecified'"
                            />
                        }
                        @if (model.country) {
                            <medpace-labeled-text [label]="'Country'" [text]="model.country" />
                        }
                    }
                    @if (model.details) {
                        <medpace-labeled-text [label]="'Additional Details'" [text]="model.details" />
                    }
                </div>
            }
        } @else if (data.mode === 'edit') {
            @if (data.formGroup; as formGroup) {
                <!-- EDIT/CREATE MODE -->
                <div class="flex flex-col gap-medpace">
                    <p class="text-sm text-gray-600">
                        <span class="text-red-500">*</span>
                        indicates a required field
                    </p>

                    <mds-checkbox
                        [formCtrl]="formGroup.controls.primary"
                        [label]="'Make Primary?'"
                        [id]="'makePrimary'"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.firstName"
                        [appearance]="'outline'"
                        [label]="'First/Given Name'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        id="firstName"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.middleName"
                        [appearance]="'outline'"
                        [label]="'Middle Name'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        id="middleName"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.lastName"
                        [appearance]="'outline'"
                        [label]="'Last/Surname'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        id="lastName"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.phone"
                        [appearance]="'outline'"
                        [label]="'Phone Number'"
                        [placeholder]="'Type here...'"
                        [inputType]="'tel'"
                        id="phone"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.email"
                        [appearance]="'outline'"
                        [label]="'Email Address'"
                        [placeholder]="'Type here...'"
                        [inputType]="'email'"
                        id="email"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.relationship"
                        [appearance]="'outline'"
                        [label]="'Relationship to Patient'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        id="relationship"
                    />

                    <mds-text-field
                        [formCtrl]="formGroup.controls.preferredLang"
                        [appearance]="'outline'"
                        [label]="'Preferred Language'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        id="preferredLang"
                    />

                    <mds-radio-group
                        [label]="'Gender'"
                        [buttons]="genderRadioButtons"
                        [formCtrl]="formGroup.controls.gender"
                        id="gender"
                        [required]="true"
                    />

                    <mds-datepicker
                        [formCtrl]="formGroup.controls.birthDate"
                        [appearance]="'outline'"
                        [label]="'Birthdate'"
                        id="birthDate"
                    />

                    <mds-radio-group
                        [buttons]="addressRadioButtons"
                        [formCtrl]="formGroup.controls.addressSameAsPatient"
                        id="addressSameAsPatient"
                        [label]="'Same Address as Patient?'"
                        [required]="true"
                    />

                    @if (form?.addressSameAsPatient().value() === false) {
                        <mds-text-field
                            [formCtrl]="formGroup.controls.address.controls.address1"
                            [appearance]="'outline'"
                            [label]="'Address Line 1'"
                            [placeholder]="'Type here...'"
                            [inputType]="'text'"
                            id="address1"
                            appGoogleMapsAutocomplete
                            (placeChangeEvent)="googleMapsAutocompletePlaceChange($event)"
                        />

                        <mds-text-field
                            [formCtrl]="formGroup.controls.address.controls.address2"
                            [appearance]="'outline'"
                            [label]="'Address Line 2'"
                            [placeholder]="'Type here...'"
                            [inputType]="'text'"
                            id="address2"
                        />

                        <mds-text-field
                            [formCtrl]="formGroup.controls.address.controls.city"
                            [appearance]="'outline'"
                            [label]="'City'"
                            [placeholder]="'Type here...'"
                            [inputType]="'text'"
                            id="city"
                        />

                        <mds-text-field
                            [formCtrl]="formGroup.controls.address.controls.state"
                            [appearance]="'outline'"
                            [label]="'State/Region'"
                            [placeholder]="'Type here...'"
                            [inputType]="'text'"
                            id="state"
                        />

                        <mds-text-field
                            [formCtrl]="formGroup.controls.address.controls.zipcode"
                            [appearance]="'outline'"
                            [label]="'Zipcode/Postal Code'"
                            [placeholder]="'Type here...'"
                            [inputType]="'text'"
                            id="zipcode"
                        />

                        <mds-autocomplete
                            [closeOnPageScroll]="false"
                            [disableRipple]="false"
                            [formCtrl]="formGroup.controls.address.controls.country"
                            [options]="countryNames()"
                            appearance="outline"
                            placeholder="Enter country"
                            label="Country"
                            id="country"
                            [validateInput]="true"
                        />
                    }

                    <mds-text-field
                        [formCtrl]="formGroup.controls.details"
                        [appearance]="'outline'"
                        [label]="'Additional Details'"
                        [placeholder]="'Type here...'"
                        [inputType]="'text'"
                        id="details"
                    />
                </div>
            }
        }
    </mds-dialog-content>

    <mds-dialog-actions>
        <div class="flex flex-row gap-medpace">
            <mds-button [id]="'cancel-btn'" [variant]="'outline'" [label]="'Cancel'" (clickEvent)="onCancel()" />
            @if (data.mode === 'edit') {
                <mds-button
                    [id]="'save-btn'"
                    [color]="'primary'"
                    [variant]="'filled'"
                    [label]="data.formGroup.model === null ? 'Add Caregiver' : 'Save'"
                    (clickEvent)="onSave()"
                />
            }
        </div>
    </mds-dialog-actions>
</mds-dialog>
